import { consume } from '@lit/context';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { global, GlobalComponentType } from '@/context';
import { ApiService } from '@/types';
import { uploadFileToEndpoint } from '@/utils';

import '../../loader/fg-loader';

@customElement('fg-step-uploading')
export class FgStepUploading extends LitElement {
  @property({ type: Object })
  file?: File | null;

  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  firstUpdated() {
    if (this.file) {
      uploadFileToEndpoint(
        this,
        { file: this.file as Blob },
        ApiService.LOGO,
        'file-uploaded-successfully',
        'upload-error',
        this.globalContext.locale,
      );
    }
  }

  render() {
    if (!this.file) {
      return null;
    }

    return html`
      <fg-loader type="uploader"></fg-loader>
    `;
  }
}
